export default "__VITE_ASSET__67196d2a__"